import { INotificationDisplayDetails } from 'app-core/src/models/notification-display-details.model';
import { IExposableService } from './exposable-service.inteface';

// -----------------------------------------------------------------------------
export const kNameOfNotificationWindowService = 'NotificationWindowService';

// -----------------------------------------------------------------------------
export interface INotificationWindowService extends IExposableService {
  getActiveNotification(): Promise<INotificationDisplayDetails>;
  notificationBecameVisible();
  toggleTimeoutTimer(pause: boolean);
  closeNotificationWindow();
  getNotificationStopWatchTime();
}
